// extracted by mini-css-extract-plugin
export default {"hiddenButtonRoot":"HiddenButton_hiddenButtonRoot__q8WfP"};